export const API_PATH_ApiDeviceMgmtRegionArchive = '/services/devices-mgtm/apiDeviceMgmtRegionArchive';
